import { ReactNode } from "react";
import { Button } from "@progress/kendo-react-buttons";

type Props = {
  onClick?: () => void;
  children?: ReactNode;
};

export const WhiteButton = ({ onClick, children }: Props) => {
  return (
    <Button style={{ backgroundColor: "#fff" }} onClick={onClick}>
      {children}
    </Button>
  );
};
